// Standalone Infographics page (`/infographics/`).
// Card thumb: the titled landscape header (*-preview.png).
// Blog cards and social meta images stay on the untitled feature image from the blog API.
// topic matches that post's tag.
// Download: the singular large *-infographic.png (not the zip).
// blogHref is set only when a matching published post exists.

const infographics = [
  {
    id: "professional-marketing-email",
    title:
      "How to create a professional marketing email (without a designer or copywriter)",
    description:
      "Nine steps from blank page to sent, covering your brand, template, call to action, subject line and send time. No designer or copywriter needed.",
    topic: "Email marketing",
    previewImage: "/infographics/professional-marketing-email-preview.png",
    downloadUrl: "/infographics/professional-marketing-email.png",
    downloadFilename: "professional-marketing-email.png",
    blogHref:
      "/blog/how-to-create-a-professional-marketing-email-without-a-designer-or-copywriter/178/",
  },
  {
    id: "win-back-past-clients",
    title: "How to win back past clients with a reactivation campaign",
    description:
      "Six simple steps to bringing past clients back, from building the right list and offer to following up with the people who click.",
    topic: "Marketing strategy",
    previewImage: "/infographics/win-back-past-clients-preview.png",
    downloadUrl: "/infographics/win-back-past-clients.png",
    downloadFilename: "win-back-past-clients.png",
    blogHref:
      "/blog/how-to-win-back-past-clients-with-a-reactivation-campaign/177/",
  },
  {
    id: "sms-marketing-examples",
    title: "12 SMS marketing examples and campaign ideas for 2026",
    description:
      "Twelve ready-to-adapt text templates — welcome, launch, abandoned cart, reminders and win-back — plus a five-check list before you send.",
    topic: "SMS & social",
    previewImage: "/infographics/sms-marketing-examples-preview.png",
    downloadUrl: "/infographics/sms-marketing-examples.png",
    downloadFilename: "sms-marketing-examples.png",
    blogHref:
      "/blog/12-sms-marketing-examples-and-campaign-ideas-for-2026/171/",
  },
  {
    id: "white-label-marketing-platforms",
    title: "6 best white-label marketing platforms for agencies in 2027",
    description:
      "A side-by-side look at Transpond, HighLevel, Vendasta, DashClicks, ActiveCampaign and Cloud Campaign — and what to look for when you pick.",
    topic: "Marketing strategy",
    previewImage: "/infographics/white-label-marketing-platforms-preview.png",
    downloadUrl: "/infographics/white-label-marketing-platforms.png",
    downloadFilename: "white-label-marketing-platforms.png",
    blogHref:
      "/blog/6-best-white-label-marketing-platforms-for-agencies-in-2026/173/",
  },
  {
    id: "marketing-tool-benefits",
    title: "7 benefits of using a marketing tool for your business",
    description:
      "Why one toolkit beats a pile of tabs: branded emails, forms, conversations, SMS, automations, social scheduling and AI drafts.",
    topic: "Marketing strategy",
    previewImage: "/infographics/marketing-tool-benefits-preview.png",
    downloadUrl: "/infographics/marketing-tool-benefits.png",
    downloadFilename: "marketing-tool-benefits.png",
    blogHref:
      "/blog/7-benefits-of-using-a-marketing-tool-for-your-business/153/",
  },
  {
    id: "data-led-marketing",
    title:
      "Data-led marketing: how to get started with information you already have",
    description:
      "Use the CRM and purchase data you already have — five steps from a small list to campaigns that feel personal, not generic.",
    topic: "Marketing strategy",
    previewImage: "/infographics/data-led-marketing-preview.png",
    downloadUrl: "/infographics/data-led-marketing.png",
    downloadFilename: "data-led-marketing.png",
    blogHref:
      "/blog/data-led-marketing-how-to-get-started-with-information-you-already-have/154/",
  },
  {
    id: "marketing-mistakes",
    title: "5 marketing mistakes businesses make",
    description:
      "The five habits that stall campaigns — and the simple fix for each, from picking a channel to measuring what actually matters.",
    topic: "Marketing strategy",
    previewImage: "/infographics/marketing-mistakes-preview.png",
    downloadUrl: "/infographics/marketing-mistakes.png",
    downloadFilename: "marketing-mistakes.png",
    blogHref:
      "/blog/five-marketing-mistakes-businesses-make-and-how-to-fix-them/152/",
  },
  {
    id: "email-deliverability-checklist",
    title: "Email deliverability checklist: 15 checks before your next campaign",
    description:
      "Fifteen pre-send checks across foundations, list health, sender trust and monitoring — so the campaign lands in the inbox.",
    topic: "Email marketing",
    previewImage: "/infographics/email-deliverability-checklist-preview.png",
    downloadUrl: "/infographics/email-deliverability-checklist.png",
    downloadFilename: "email-deliverability-checklist.png",
    blogHref:
      "/blog/email-deliverability-checklist-15-checks-before-your-next-campaign/175/",
  },
  {
    id: "groups-vs-segments",
    title: "Groups vs segments — which should you use?",
    description:
      "When to use a group, when to use a segment, and why the two work better together — including how they sync with your CRM.",
    topic: "Email marketing",
    previewImage: "/infographics/groups-vs-segments-preview.png",
    downloadUrl: "/infographics/groups-vs-segments.png",
    downloadFilename: "groups-vs-segments.png",
    blogHref:
      "/blog/groups-vs-segments-which-should-you-use-and-why-it-matters/165/",
  },
  {
    id: "marketing-advice-for-beginners",
    title: "Marketing advice for beginners: you don't have to be an expert",
    description:
      "Start where you already are — build on what works, show up consistently, pick a channel, and measure just enough to improve.",
    topic: "Marketing strategy",
    previewImage: "/infographics/marketing-advice-for-beginners-preview.png",
    downloadUrl: "/infographics/marketing-advice-for-beginners.png",
    downloadFilename: "marketing-advice-for-beginners.png",
    blogHref:
      "/blog/marketing-advice-for-beginners-why-you-dont-need-to-be-an-expert-to-get-started/155/",
  },
  {
    id: "marketing-metrics",
    title: "Marketing metrics — what to track across email, SMS and social",
    description:
      "Match the metric to the goal: email, SMS and social numbers that tell you what to do next, without drowning in reports.",
    topic: "Marketing strategy",
    previewImage: "/infographics/marketing-metrics-preview.png",
    downloadUrl: "/infographics/marketing-metrics.png",
    downloadFilename: "marketing-metrics.png",
    blogHref:
      "/blog/marketing-metrics-what-to-measure-across-email-sms-and-social/169/",
  },
  {
    id: "multi-channel-marketing",
    title: "Multi-channel marketing for SMBs: a practical guide",
    description:
      "Give each channel a job, reuse your best ideas, and start small — without adding another tool to the pile.",
    topic: "Marketing strategy",
    previewImage: "/infographics/multi-channel-marketing-preview.png",
    downloadUrl: "/infographics/multi-channel-marketing.png",
    downloadFilename: "multi-channel-marketing.png",
    blogHref:
      "/blog/multi-channel-marketing-for-smbs-a-practical-guide/168/",
  },
  {
    id: "real-estate-sms",
    title: "Real estate text message marketing — a practical SMS guide for agents",
    description:
      "Templates, segmentation and automation for the buyer journey — plus when to text, when to email, and what to measure.",
    topic: "SMS & social",
    previewImage: "/infographics/real-estate-sms-preview.png",
    downloadUrl: "/infographics/real-estate-sms.png",
    downloadFilename: "real-estate-sms.png",
    blogHref:
      "/blog/real-estate-text-message-marketing-a-practical-sms-guide-for-agents/163/",
  },
  {
    id: "sms-vs-email",
    title: "SMS vs email marketing",
    description:
      "When to text, when to email, and when to use both — launches, reminders, newsletters, carts and same-day changes.",
    topic: "Marketing strategy",
    previewImage: "/infographics/sms-vs-email-preview.png",
    downloadUrl: "/infographics/sms-vs-email.png",
    downloadFilename: "sms-vs-email.png",
    blogHref:
      "/blog/sms-vs-email-marketing-when-to-use-each-and-when-to-use-both/170/",
  },
  {
    id: "content-calendar",
    title: "What is a content calendar?",
    description:
      "Four questions to start one, what to include, how to spot the gaps, and the mistakes that make a calendar gather dust.",
    topic: "Marketing strategy",
    previewImage: "/infographics/content-calendar-preview.png",
    downloadUrl: "/infographics/content-calendar.png",
    downloadFilename: "content-calendar.png",
    blogHref: "/blog/what-is-a-content-calendar-template/167/",
  },
  {
    id: "landing-page",
    title: "What is a landing page?",
    description:
      "How a landing page differs from a homepage, the four essentials, and six steps to build one in minutes.",
    topic: "Marketing strategy",
    previewImage: "/infographics/landing-page-preview.png",
    downloadUrl: "/infographics/landing-page.png",
    downloadFilename: "landing-page.png",
    blogHref:
      "/blog/what-is-a-website-landing-page-and-how-to-build-one-in-minutes/166/",
  },
  {
    id: "sms-campaign",
    title: "What is an SMS campaign?",
    description:
      "The six stages of a text campaign, the customer moments that fit SMS, and how to tell if it worked.",
    topic: "SMS & social",
    previewImage: "/infographics/sms-campaign-preview.png",
    downloadUrl: "/infographics/sms-campaign.png",
    downloadFilename: "sms-campaign.png",
    blogHref:
      "/blog/what-is-an-sms-campaign-why-texting-still-works-for-marketing/164/",
  },
  {
    id: "mcp-marketing",
    title: "What's an MCP and how can I use it in my marketing?",
    description:
      "A plain-English look at connecting your marketing tools once — you stay in control, and the assistant can ask better questions.",
    topic: "Marketing strategy",
    previewImage: "/infographics/mcp-marketing-preview.png",
    downloadUrl: "/infographics/mcp-marketing.png",
    downloadFilename: "mcp-marketing.png",
    blogHref:
      "/blog/whats-an-mcp-and-how-can-i-use-it-with-my-marketing/151/",
  },
  {
    id: "email-open-rate",
    title: "What's a good email open rate? 2026/2027 benchmarks by industry",
    description:
      "How opens are calculated, why benchmarks vary, and what to change first if yours is dropping.",
    topic: "Email marketing",
    previewImage: "/infographics/email-open-rate-preview.png",
    downloadUrl: "/infographics/email-open-rate.png",
    downloadFilename: "email-open-rate.png",
    blogHref:
      "/blog/whats-a-good-email-open-rate-2026-2027-benchmarks-by-industry/161/",
  },
  {
    id: "white-label-email-marketing",
    title:
      "White label email marketing: pricing, reseller models and agency margins",
    description:
      "Fee is not margin. Pricing models, reseller vs white-label vs referral, and a checklist before you pick a platform.",
    topic: "Email marketing",
    previewImage: "/infographics/white-label-email-marketing-preview.png",
    downloadUrl: "/infographics/white-label-email-marketing.png",
    downloadFilename: "white-label-email-marketing.png",
    blogHref:
      "/blog/white-label-email-marketing-pricing-reseller-models-and-agency-margins/172/",
  },
  {
    id: "emails-going-to-spam",
    title: "Why are my emails going to spam?",
    description:
      "Five likely causes, a side-by-side troubleshooting path, and why you should change one thing at a time.",
    topic: "Email marketing",
    previewImage: "/infographics/emails-going-to-spam-preview.png",
    downloadUrl: "/infographics/emails-going-to-spam.png",
    downloadFilename: "emails-going-to-spam.png",
    blogHref: "/blog/why-are-my-emails-going-to-spam/162/",
  },
];

export default infographics;
